import { useCallback } from "react";
import logo from "../assets/images/weviira.png";
const style = `
/* General Body Styles */
body {
  font-family: "Arial", sans-serif;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  color: #333;
  background-color: #f9f9f9;
  font-weight: 900;
  min-height: 100vh;
  overflow: hidden;
}

/* Page Settings for Tiny Half-A4 Invoice Printing */
@page {
  size: A4 portrait;
   /* Reduce margins for smaller invoices */
}

/* Invoice Container - Tiny Half A4 */
.container {
  text-align: center;
  width: 95mm; /* Even smaller width */
  // margin: 0 auto;
  padding: 12px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: auto;
}

/* Invoice Header */
.invoice-header h2 {
  margin: 0;
  text-align: center;
  font-size: 14px;
  color: #2c3e50;
  font-weight: 900;
}

/* Compact Layout */
.row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 5px;
  margin-bottom: 5px;
}

/* Client Info */
.client-info {
  flex: 1;
  padding: 3px;
  font-size: 12px;
  font-weight: 500;
}

/* Invoice Table */
table {
  width: 100%;
  border-collapse: collapse;
  margin: 2px 0;
  font-size: 10px; /* Smaller font size */
}

th, td {
  border: 1px solid black !important;
  padding: 1px;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}

th {
  background-color: #2c3e50;
  color: #fff;
}

/* Summary Table */
.summary-table {
  margin-top: 5px;
  text-align: left;
}

.summary-table td {
  padding: 2px;
  font-size: 12px;
}

/* Small Logo */
.logo {
  width: 40px;
  height: auto;
}

/* Invoice Box */
.invoice {
  padding: 5px;
  // margin: 8px auto;
  width: 95mm; /* Smaller invoice width */
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  page-break-before: always; /* Ensures each invoice starts on a new page */
  page-break-after: always; /* Forces invoices to be printed separately */
  break-inside: avoid; /* Prevents breaking inside the invoice */
}

@media print {
  body {
    background-color: #fff !important;
    margin: 0;
    padding: 0;
    display: block; /* Disable flexbox for print */
  }

  .container {
    max-width: 150mm; /* Ensures tiny invoice width */
    box-shadow: none !important;
    padding: 0;
  }

  table {
    font-size: 12px;
  }

  th, td {
    padding: 1px;
  }

  .page-break {
    page-break-before: always;
    page-break-after: always;
    page-break-inside: avoid;
  }

  .row, .client-info, .summary-table {
    page-break-inside: avoid;
  }
}


`;

const usePrintInvoices = () => {
  const printInvoices = useCallback((data) => {
    try {
      console.log(data);
      const btns = ` <div
  style="
    position: fixed;
    bottom: 20px;
    right: 20px;
    display: flex;
    gap: 10px;
  "
>
  <button
    onclick="window.print()"
    style="
      padding: 10px 20px;
      font-size: 16px;
      background-color: #4caf50;
      color: white;
      border: none;
      cursor: pointer;
    "
  >
    طباعة
  </button>
  <button
    onclick="window.location.reload()"
    style="
      padding: 10px 20px;
      font-size: 16px;
      background-color: #234356;
      color: white;
      border: none;
      cursor: pointer;
    "
  >
    عودة
  </button>
</div>
`;

      const printWindow = window.open("", "_blank");

      const today = new Date(data[0].invoices[0].dailyDate);
      const optionsDate = { 
        year: "numeric", 
        month: "long", 
        day: "numeric",
        calendar: "gregory"
      };
      const optionsDay = { 
        weekday: "long",
        calendar: "gregory"
      };
      const arabicDate = today.toLocaleDateString("ar-EG", optionsDate);
      const arabicDay = today.toLocaleDateString("ar-EG", optionsDay);
      const invoiceData = data[0].invoices;
      const rows = data[0].invoices
        .map(
          (item) => `
      <div class="invoice">


      <div class="row">
        <div class="client-info">
          <p><strong>الكود:</strong> ${item.invoiceCode || "N/A"}</p>
          <p><strong>اسم العميل:</strong> ${item.customer || "N/A"}</p>
          <p><strong>العنوان:</strong> ${item.address || "N/A"}</p>
          <p><strong>الهاتف:</strong> ${item.phone || "N/A"}</p>
          <p><strong>المحافظة:</strong> ${item.governorate?.name || "N/A"}</p>
          <p><strong>الملاحظات:</strong> ${item.note || "N/A"}</p>
            <p><strong>الرقم الثاني:</strong> ${item.socendPhone || "N/A"}</p>
        </div>
        <div class="client-info">
          <p><strong>تاريخ الفاتورة:</strong> ${
            new Date(item.invoiceDate).toLocaleDateString("ar-EG") || "N/A"
          }</p>
          <p><strong>السكرتير:</strong> ${item.userName || "N/A"}</p>
          <p><strong>المندوب:</strong> ${
            item.representative?.fullName || "N/A"
          }</p> 
          <p><strong>الصفحه:</strong> ${
            item.page || "N/A"
          }</p>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>الصنف</th>
            <th>الكمية</th>
            <th>السعر</th>
            <th>الإجمالي</th>
          </tr>
        </thead>
        <tbody>
          ${(item.items || [])
            .map(
              (category) => `
            <tr>
              <td>${category.category?.name || "N/A"}</td>
              <td>${category.quantity || 0}</td>
              <td>${category.price || 0}</td>
              <td>${category.total || 0}</td>
            </tr>`
            )
            .join("")}
        </tbody>
      </table>

      <table class="summary">
        <tbody>
          <tr><td>الاجمالي</td><td>${item.totalPrice - item.shipping}</td></tr>
          <tr><td>الشحن</td><td>${item.shipping || 0}</td></tr>
          <tr class="total"><td>الاجمالي مع الشحن</td><td>${
            item.totalPrice
          }</td></tr>
        </tbody>
      </table>
    </div>
    `
        )
        .join("");

      let indx = 0;
      const accountRows = `
        <div>

                  <div style="display: flex; ">

</div>
          <h3 style="text-align: center;">اذن صرف بضاعه</h3>
                  <h3>المندوب   / ${
                    invoiceData[0].representative.fullName || "N/A"
                  }  </h3> 
         <h3>التاريخ / ${arabicDate}</h3>
    <h3>اليوم / ${arabicDay}</h3>
          
        </div>
      `;

      const invoiceDetailsRows = invoiceData
        .map(
          (invoice, idx) => `
      <tr>
        <td>${idx + 1 || "N/A"}</td>

        <td>${invoice.invoiceCode || "N/A"}</td>
        <td>${
          invoice.items.map((item) => item.category.name).join(", ") || "N/A"
        }</td>
              <td>${invoice.items.length || 0}</td>
        <td>${invoice.shipping || 0}</td>
        <td>${invoice.totalPrice - invoice.shipping || 0}</td>
                <td>${invoice.totalPrice || 0}</td>

        <td>${invoice?.governorate?.name || "N/A"}</td>
        <td>${invoice.status || "N/A"}</td>
      </tr>
    `
        )
        .join("");

      let finalTotal = 0;
      let totalQuantity = 0;
      let totalPrice = 0;
      let totalCount = 0;

      for (let i = 0; i < invoiceData.length; i++) {
        totalQuantity += invoiceData[i].totalPrice - invoiceData[i].shipping;
        totalPrice += invoiceData[i].shipping;
        totalCount += invoiceData[i].items.length;
      }

      finalTotal = totalQuantity + totalPrice;

      const totalsTable = `
  <table border="1" style="width: 50%; text-align: center; border-collapse: collapse;">
    <thead>
      <tr>
              <th> اجمالي  العدد</th>
        <th> اجمالي القيمه</th>
        <th> اجمالي الشحن</th>
        <th> الاجمالي النهائي</th>
      </tr>
    </thead>
    <tbody>
      <tr>
            <td>${totalCount}</td>
        <td>${totalQuantity}</td>
        <td>${totalPrice}</td>
        <td>${finalTotal}</td>
      </tr>
    </tbody>
  </table>
`;

      const invoiceDetailsTable = `
<div class="page-break"> 
              <div style="display: flex; justify-content: flex-end;">

</div>
          
<div style="margin-bottom: 10px; display: flex; justify-content: space-between;">
  <h3 style="margin: 0; padding: 0 8px; font-size: 0.75rem;">المندوب / ${
    invoiceData[0].representative.fullName || "N/A"
  }</h3>
  <h3 style="margin: 0; padding: 0 8px; font-size: 0.75rem;">التاريخ / ${arabicDate}</h3>
  <h3 style="margin: 0; padding: 0 8px; font-size: 0.75rem;">اليوم / ${arabicDay}</h3>
</div>



    

  <table border="1" style="width: 100%; text-align: center; border-collapse: collapse;">
    <thead>
      <tr>
              <th>الفهرس</th>

        <th>كود الفاتورة</th>
        <th> بيان  الاصناف</th>

        <th>عدد الاصناف</th>
        <th>الشحن</th>
        <th>القيمة</th>
        <th>الاجمالي</th>
        <th>المحافظة</th>
        <th>الحالة</th>
      </tr>
    </thead>
    <tbody>
      ${invoiceDetailsRows || `<tr><td colspan="6">لا توجد بيانات</td></tr>`}
    </tbody>
  </table>

  ${totalsTable}
<h3 style="margin-top: 10px; text-align: center">  ${totalCount} / العدد  </h3>


        <h3  style="font-size: 12px;"> المستحق /    </h3> 
            <h3 style="font-size: 12px;">النقدي   /   </h3> 
            <h3 style="font-size: 12px;">المسدد   /   </h3> 


            
</div>
`;
      let ItemsCounts = 0;
      data[0].categoryTotals.forEach((category) => {
        ItemsCounts += category.totalQuantity;
      });

      const categoryTotalsRows = data[0].categoryTotals
        .map(
          (total) => `
            <tr>
              <td>${total.categoryName || "N/A"}</td>
              <td>${total.totalQuantity || 0}</td>
            </tr>
          `
        )
        .join("");

      const categoryTotals = `
    <div width="70%" style="margin: 0 auto">  

        <table border="1" style="width: 200px; margin-top: 70px; text-align: center; border-collapse: collapse;">
          <thead>
            <tr>
              <th width="120px"> مجموعه الاصناف</th>
              <th> العدد</th>
            </tr>
          </thead>
          <tbody>
            ${
              categoryTotalsRows ||
              `<tr><td colspan="2">لا توجد بيانات</td></tr>`
            }
          </tbody>
        </table> 
    <p> اجمالي العدد: ${ItemsCounts} </p>
                <p>توقيع المندوب: ____________________</p>
    
    </div>
      `;

      const invoiceTables = `
        <h3>المندوب   / ${
          invoiceData[0].representative.fullName || "N/A"
        }  </h3> 
            <h3> التاريخ /    </h3> 
            <h3>اليوم   /   </h3> 
        <table>
          <thead>
            <tr>
              <th>  بيان الاصناف</th>
              <th>العدد</th>
            </tr>
          </thead>
          <tbody>
            ${data
              .flatMap((item) => item.items || [])
              .map(
                (category) => `
                  <tr>
                    <td>${category.category.group.name || "N/A"}</td>
                    <td>${category.quantity || 0}</td>
                  </tr>
                `
              )
              .join("")}
          </tbody>
        </table>
        <p>التوقيع: ____________________</p>
        <hr>
      `;

      const invoicesPage = `  <html>
          <head>
            <title>فواتير</title>
  
          </head> 
          <style>${style}
          </style>
          <body>
  <!-- First Section: Rows -->
  <div style="min-height: 100vh; display: flex; justify-content: start; align-items: start; box-sizing: border-box; flex-direction: column;">
    ${rows}
  </div>



  ${btns}

</body>


        </html>
      `;

      const permissionPage = `  <html>
      <head>
        <title>اذن الصرف</title>

      </head> 
          <style>${style}
          </style>
      <body>

<div style=" display: flex; justify-content: center; align-items: center; box-sizing: border-box; flex-direction: column;">
<div style="margin-top: 10px;">
  ${accountRows}
  ${categoryTotals}
</div>
</div>

${btns}

</body>


    </html>
  `;
      const accountsPage = `  <html>
  <head>
    <title>تجميع الحساب</title>

  </head> 
  <style>
  
  ${style}
  </style>
  <body>

 

<div style=" display: flex; justify-content: center; align-items: center; box-sizing: border-box;">
${invoiceDetailsTable} 

</div>
${btns}
</body>


</html>
`;

      const permissionsTab = window.open("", "permissionsTab");
      permissionsTab.document.write(permissionPage);
      permissionsTab.document.close();

      const invoicesTab = window.open("", "invoicesTab");
      invoicesTab.document.write(invoicesPage);
      invoicesTab.document.close();

      const accountsTab = window.open("", "accountsTab");
      accountsTab.document.write(accountsPage);
      accountsTab.document.close();
    } catch (error) {
      console.error("Error printing invoices:", error);
    }
  }, []);

  return printInvoices;
};

export default usePrintInvoices;
